
import LayoutCardCaption from './LayoutCardCaption.vue';
import { includesValidator } from '../../common/utils/validator';

const ButtonsPlacement = {
  TopRight: 'top-right',
  BottomRight: 'bottom-right',
};

export default {
  name: 'BbLayoutCard',
  components: { LayoutCardCaption },
  props: {
    caption: {
      type: [String, Array],
      default: '',
    },
    defaultImage: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    tags: {
      type: Array,
      default: () => [],
    },
    hideImage: {
      type: Boolean,
      default: false,
    },
    dragged: {
      type: Boolean,
      default: false,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    buttonsPlacement: {
      type: String,
      default: ButtonsPlacement.BottomRight,
      validator: includesValidator(ButtonsPlacement),
    },
  },
  computed: {
    image() {
      return this.src ? this.src : this.defaultImage;
    },
    showTags() {
      return !!this.tags.length;
    },
  },
};
